export const PORTRAIT_SUPER_ADMIN = 'PORTRAIT_SUPER_ADMIN';
export const ZHUGE_AUTH = ['zhuge_datashow'];
